"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);

exitAnime();

// KV アニメーション
window.addEventListener(
  "load",
  () => {
    gsap
      .timeline({
        defaults: {
          ease: "power2.out",
        },
      })
      /* square */
      .to(
        ".layer-square__cont",
        {
          ease: "Power2.easeInOut",
          duration: 0.3,
          x: 0,
          stagger: {
            from: "random",
            amount: 0.3,
          },
        },
        0
      )
      .add(function () {
        document.querySelector(".layer-kv-ttl").classList.add("exit");
      }, 0.5)
      .add(function () {
        document.querySelector(".layer-kv__fig").classList.add("exit");
      }, 1.2);
  },
  false
);

// 下のタブをクリックすると上部に戻る
const tabListAbove = document.querySelector(".tab-list--above");
const tabScrollTrigger = document.querySelectorAll(".tab-list__item--below");
for (let i = 0; i < tabScrollTrigger.length; i++) {
  tabScrollTrigger[i].addEventListener("click", (e) => {
    let offsetTop = window.pageYOffset;
    window.scrollTo({
      top: offsetTop + tabListAbove.getBoundingClientRect().top,
      behavior: "smooth",
    });
  });
}

// 押下したタブによって中身を切り替える
let tabItem = document.querySelectorAll(".tab-list__item");
let contents = document.querySelectorAll(".tab-cont");

for (let i = 0; i < tabItem.length; i++) {
  tabItem[i].addEventListener(
    "click",
    (e) => {
      //- 現在acitveになっているタブ・メインコンテンツから、クラスを削除
      let activeTab = document.querySelectorAll(".tab-list__item.active");
      activeTab[0].classList.remove("active");
      activeTab[1].classList.remove("active");
      document.querySelector(".tab-cont.active").classList.remove("active");

      //- クリックしたタブと連動するタブ、メインコンテンツにクラスを付与
      let current = e.currentTarget;
      let activeNumber = current.dataset.tab;
      current.classList.add("active");
      document
        .querySelector(
          '.tab-list__item[data-tab="' + activeNumber + '"]:not(.active)'
        )
        .classList.add("active");
      contents[activeNumber].classList.add("active");
      exitAnime();
    },
    false
  );
}

//- 開いているメインコンテンツの中のまだアニメーションが作動していない要素にのみクラスを付与
function exitAnime() {
  let target = document.querySelectorAll(
    ".tab-cont.active .anim--tab:not(.exit)"
  );
  target.forEach((item) => {
    ScrollTrigger.create({
      trigger: item,
      start: "top 75%",
      once: true,
      onEnter: () => {
        item.classList.add("exit");
      },
    });
  });
}

// 閉じる専用ボタン
const closeBtn = document.querySelectorAll(".js-accordion-close");
for (let i = 0; i < closeBtn.length; i++) {
  closeBtn[i].addEventListener("click", function () {
    const target = this.parentNode;
    target.classList.remove("is-open");
    target.previousElementSibling.classList.remove("is-active");
    gsap.to(target, {
      height: 0,
      duration: 0.5,
      ease: "power2.inOut",
    });
  });
}

/*
const tabArea = document.querySelectorAll(".tab-list"); // タブのブロック(ul)
const tabs = document.querySelectorAll(".tab-list__above li"); // 上部のタブ
const tabsBel = document.querySelectorAll(".tab-list__below li"); // 下部のタブ
const contents = document.querySelectorAll(".tab__cont"); // タブのコンテンツ
const contentTitle = document.querySelectorAll(".layer-sec-head");


function remActive() {
  // 上部タブの全てのactiveを外す
  for (let j = 0; j < tabs.length; j++) {
    tabs[j].classList.remove("active");
    contents[j].classList.remove("active");
    tabsBel[j].classList.remove("active");
  }
}
function tabsAnime() {
  for (let c = 0; c < contentTitle.length; c++) {
    const target = document.querySelectorAll(".active .js-inview");
    target.forEach((item) => {
      gsap.to(target, {
        scrollTrigger: {
          trigger: item,
          start: "top 65%",
          once: true,
          onEnter: () => {
            item.classList.add("is-view");
          },
        },
      });
    });
  }
}
tabArea.forEach(() => {
  for (let i = 0; i < tabs.length; i++) {
    // i番目のタブをクリック
    tabs[i].addEventListener("click", function (e) {
      // 上部タブの全てのactiveを外す
      remActive();
      this.classList.add("active");
      contents[i].classList.add("active");
      tabsBel[i].classList.add("active");
      tabsAnime();
    });
    tabsBel[i].addEventListener("click", function (e) {
      remActive();
      this.classList.add("active");
      contents[i].classList.add("active");
      tabs[i].classList.add("active");
      tabsAnime();
    });
  }
  // 会社概要タブの事業紹介箇所をクリックしたら、事業紹介タブに移動する。
  /*
  const tableSwitch = document.querySelector(".profile-table__switch");
  tableSwitch.addEventListener("click", () => {
    remActive();
    tabsBel[1].classList.add("active");
    tabs[1].classList.add("active");
    contents[1].classList.add("active");
    tabsAnime();
    window.scroll({
      top: kvContent,
      behavior: "smooth",
    });
  });
});
*/
